import { call, put, takeLatest } from "redux-saga/effects";
import {
  createTransactionDriverFailure,
  createTransactionDriverStart,
  createTransactionDriverSuccess,
  getTransactionDriversFailure,
  getTransactionDriversStart,
  getTransactionDriversSuccess,
  updateTransactionDriverFailure,
  updateTransactionDriverStart,
  updateTransactionDriverSuccess,
  updateTransactionDriverOptimistic,
  getDriversListSuccess,
  getDriversListFailure,
  getDriversListStart,
  deleteTransactionDataStart,
  deleteTransactionDataFailure,
  deleteTransactionDataSuccess

} from "../redux-slices/transactionDriversSlice";
import { createOrUpdateTransactionDriver, getAllTransactionDrivers, getTransactionDriversList, deleteTransactionDriver } from "../../utils/apiCalls";
import { toast } from "../../components/Toast";

export default function* transactionDriversWatcher() {
  yield takeLatest(getTransactionDriversStart.type, getTransactionDriversWorker);
  yield takeLatest(createTransactionDriverStart.type, createTransactionDriverWorker);
  yield takeLatest(updateTransactionDriverStart.type, updateTransactionDriverWorker);
  yield takeLatest(getDriversListStart.type, getTransactionDriversListWorker); // deleteTransactionDriversListWorker
  yield takeLatest(deleteTransactionDataStart.type, deleteTransactionDriversListWorker); // deleteTransactionDriversListWorker

}

function* getTransactionDriversWorker(action) {
  try {
    const { limit, pageNo } = action && action.payload
    const response = yield getAllTransactionDrivers({ limit, pageNo });

    yield put(getTransactionDriversSuccess(response?.data?.data));
  } catch (error) {
    console.log("Failed to fetch data::::::::", error);

    yield toast(error?.response?.data?.errors[0]?.description, "error");
    yield put(
      getTransactionDriversFailure(
        error?.response?.data?.errors[0]?.description
      )
    );
  }
}

function* createTransactionDriverWorker(action) {
  try {
    const { data, onSuccess } = action && action.payload;

    const response = yield createOrUpdateTransactionDriver(data);
    if (response?.data?.data?.data) {
      yield put(createTransactionDriverSuccess());

      // yield toast("Driver created successfully", "success");

      if (onSuccess && typeof onSuccess === 'function') {
        yield call(onSuccess);
      }
    }
    else {
      yield toast(response?.data?.data?.message, "error");
      yield put(createTransactionDriverFailure(response?.data?.data?.message))

    }


  } catch (error) {
    yield toast(error?.response?.data?.errors[0]?.description, "error");
    yield put(createTransactionDriverFailure(error?.response?.data?.errors[0]?.description))
  }
}

function* updateTransactionDriverWorker(action) {
  try {
    const { data, onSuccess, optimisticUpdate } = action && action.payload;

    if (optimisticUpdate) {
      yield put(updateTransactionDriverOptimistic({
        transactionAgentId: data.transactionAgentId,
        newStatus: data.status
      }));
    }

    const response = yield createOrUpdateTransactionDriver(data);

    if (response?.data?.data?.data) {
      yield put(createTransactionDriverSuccess());

      // yield toast("Driver created successfully", "success");
console.log(response , onSuccess , typeof onSuccess , "tnhtrjknhtklgntr")

      if (onSuccess && typeof onSuccess === 'function') {
        yield call(onSuccess);
      }
     
    }
    else {
      yield toast(response?.data?.data?.message, "error");
      yield put(createTransactionDriverFailure(response?.data?.data?.message))

    }

  } catch (error) {
    yield toast(error?.response?.data?.errors[0]?.description, "error");

    const { data, previousStatus } = action.payload;
    yield put(updateTransactionDriverFailure({
      error: error?.response?.data?.errors[0]?.description,
      transactionAgentId: data.transactionAgentId,
      previousStatus
    }));
  }
}

function* getTransactionDriversListWorker() {
  try {
    const response = yield getTransactionDriversList()

    yield put(getDriversListSuccess(response?.data?.data?.agents))
  } catch (error) {
    console.log("Failed to fetch data::::::::", error);

    yield toast(error?.response?.data?.errors[0]?.description, "error");
    yield put(getDriversListFailure(error?.response?.data?.errors[0]?.description))
  }
}

// deleteTransactionDriver

function* deleteTransactionDriversListWorker(action) {
  try {
    const { data, onSuccess } = action && action.payload;
    const response = yield deleteTransactionDriver(data)
console.log({response} , "response >>>>>>>>>>>>>>>>>>>>>>>>")
    yield put(deleteTransactionDataSuccess(response?.data?.data?.agents))
    if (onSuccess && typeof onSuccess === 'function') {
      yield call(onSuccess);
    }
  } catch (error) {
    console.log("Failed to fetch data::::::::", error);

    yield toast(error?.response?.data?.errors[0]?.description, "error");
    yield put(deleteTransactionDataFailure(error?.response?.data?.errors[0]?.description))
  }
}